import styled, { css } from 'styled-components';

export const Root = styled.div`
  ${({ theme, $isMobile }) => css`
    background: ${theme.v3.colors.neutral[100]};
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: fit-content;
    box-sizing: border-box;
    padding: 28px 0;
    ${!$isMobile && css`
      padding: ${theme.v3.spacing.xxs} 0;
    `}
  `}
`;

export const BrandByMonarxWrapper = styled.div`
  ${({ theme, $isMobile }) => css`
    width: 100%;
    margin-bottom: ${theme.v3.spacing.xxxs};
    ${!$isMobile && css`
      margin-bottom: ${theme.v3.spacing.xxs};
    `}
  `}
`;

export const Headline = styled.p`
  ${({ theme, $isMobile }) => css`
    margin: 0;
    font-family: ${theme.v3.font.family.brand};
    color: ${theme.v3.colors.brand.snappyBlue[10]};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.spacious};
    text-align: center;
    width: 100%;
    font-size: ${theme.v3.font.sizes['1xmedium']};
    max-width: 280px;
    margin-bottom: ${theme.v3.spacing.xs};

    ${!$isMobile && css`
      font-size: ${theme.v3.font.sizes['1xhuge']};
      max-width: 526px;
    `}

    strong {
      font-weight: ${theme.v3.font.weights.bold};
    }
  `}
`;

export const FeaturesBlock = styled.div`
  ${({ theme, $isMobile }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.v3.spacing.xs};
    width: 100%;
    max-width: 100%;
    align-items: stretch;
    margin-bottom: ${theme.v3.spacing.xs};

    ${!$isMobile && css`
      max-width: 560px;
    `}
  `}
`;

export const FeatureRow = styled.div`
  ${() => css`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
  `}
`;

export const FeatureIconWrap = styled.div`
  ${({ theme }) => css`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: ${theme.v3.border.radius.sm};
    background: ${theme.v3.colors.brand.snappyBlue[98]};
    padding: ${theme.v3.spacing.nano};
    box-sizing: border-box;
  `}
`;

export const FeatureTexts = styled.div`
  ${() => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1 1 0;
    min-width: 0;
  `}
`;

export const FeatureTitle = styled.p`
  ${({ theme, $isMobile }) => css`
    margin: 0;
    font-family: ${theme.v3.font.family.brand};
    color: ${theme.v3.colors.brand.snappyBlue[10]};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    ${!$isMobile && css`
      font-size: ${theme.v3.font.sizes.medium};
    `}
  `}
`;

export const FeatureDescription = styled.p`
  ${({ theme }) => css`
    margin: 0;
    font-family: ${theme.v3.font.family.brand};
    color: ${theme.v3.colors.neutral[30]};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.relaxed};
  `}
`;

export const PrimaryButtonWrap = styled.div`
  ${({ theme, $isMobile }) => css`
    width: 100%;
    padding: 0 ${theme.v3.spacing.xxxs};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.v3.spacing.xxxs};

    ${!$isMobile && css`
      max-width: 330px;
      padding: 0;
    `}
  `}
`;

export const PricingFootnote = styled.p`
  ${({ theme }) => css`
    margin: 0;
    font-family: ${theme.v3.font.family.brand};
    color: ${theme.v3.colors.neutral[30]};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    text-align: center;
  `}
`;

export const PricingFootnoteSkeleton = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 280px;
    margin: 0 auto;
    height: ${theme.v3.font.sizes.small};
    display: flex;
    align-items: center;
    justify-content: center;
  `}
`;
